export default "__VITE_ASSET__741cdb16__"